import domContentLoaded from 'dom-content-loaded';
import $ from 'jquery';
import 'slick-carousel';

export default () => {
	domContentLoaded(() => {
		// メインビジュアル
		const $slider_mv = $('.js_slider-mv');
		$slider_mv.find('.js_slider_item').each((i, elm) => {
			$(elm).addClass(`js_delay_${i}`);
		});
		$slider_mv.slick({
			autoplay: true,
			arrows: false,
			dots: false,
			swipe: false,
			fade: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			// slidesToShow: 3,
			// slidesToScroll: 3,
			autoplaySpeed: 3000,
			speed: 2000,
			cssEase: 'linear',
		});
		$('.js_slider_trrigaer')
			.eq(0)
			.on('animationstart webkitAnimationStart', () => {
				$slider_mv.slick('slickPlay');
			});

		// instagram
		const $slider_insta = $('.js_topinstaslider');
		$slider_insta.slick({
			autoplay: true,
			arrows: false,
			// dots: true,
			swipe: true,
			// fade:  true,
			pauseOnFocus: false,
			pauseOnHover: true,
			// prevArrow: '<button type="button" class="slick-prev">前へ</button>',
			// nextArrow: '<button type="button" class="slick-next">次へ</button>',
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplaySpeed: 0,
			speed: 6000,
			centerMode: true,
			centerPadding: '50px',
			cssEase: 'linear',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					},
				},
			],
		});

		// WorksMainimage
		const $slider_worksMainimage = $('.js-worksSlider');
		$slider_worksMainimage.find('.js_slider_item').each((i, elm) => {
			$(elm).addClass(`js_delay_${i}`);
		});
		$slider_worksMainimage.slick({
			autoplay: true,
			arrows: true,
			dots: true,
			swipe: true,
			pauseOnFocus: false,
			pauseOnHover: false,
			prevArrow: '<button type="button" class="slick-prev">前へ</button>',
			nextArrow: '<button type="button" class="slick-next">次へ</button>',
			slidesToScroll: 1,
			autoplaySpeed: 3000,
			speed: 200,
			cssEase: 'linear',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
					},
				},
			],
		});

		// WorksOtherEntry
		const $slider_WorksOtherEntry = $(
			'.js-worksotherentry .un_works_summary_card_wrap',
		);
		$slider_WorksOtherEntry.find('.js_slider_item').each((i, elm) => {
			$(elm).addClass(`js_delay_${i}`);
		});
		$slider_WorksOtherEntry.slick({
			autoplay: true,
			arrows: true,
			// dots: true,
			swipe: true,
			// fade:  true,
			pauseOnFocus: false,
			pauseOnHover: true,
			prevArrow: '<button type="button" class="slick-prev">前へ</button>',
			nextArrow: '<button type="button" class="slick-next">次へ</button>',
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplaySpeed: 3000,
			speed: 200,
			centerMode: true,
			centerPadding: '100px',
			cssEase: 'linear',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						arrows: false,
						// speed: 200,
					},
				},
			],
		});

		// Brandimage（ループ内で複数存在するため親要素ごとに初期化）
		$('.un_brandPlan_wrap').each((i, wrap) => {
			const $for = $(wrap).find('.js-slider-for');
			const $nav = $(wrap).find('.js-slider-nav');

			$for.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: '<button type="button" class="slick-prev">前へ</button>',
				nextArrow: '<button type="button" class="slick-next">次へ</button>',
				asNavFor: $nav,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							arrows: false,
						},
					},
				],
			});
			$nav.slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				asNavFor: $for,
				dots: true,
				focusOnSelect: true,
			});
		});
	});
};
